import React from "react";

import { CheckboxComponent } from "./styles";

interface CheckboxProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  appearance?: "primary" | "secondary" | "danger" | "success" | "dark";
  checked?:boolean;
}

export function Checkbox({ id, onChange, appearance, checked }: CheckboxProps) {
  return (
    <CheckboxComponent
      type="checkbox"
      onChange={onChange}
      appearance={appearance}
      id={id}
      checked={checked}
    />
  );
}
